import { HttpClient } from '../common/http-client'
import { Environment } from '../environment/app-settings'
import {DateTime} from "luxon";

export interface IGetMobywatelQRCodeReturnProps {
   text: string;
   dateValidity: string;
}

export interface IGetMobywatelQRCodeDTO {
   
}

//#region SettingService Instance
let instance: MObywatelService
//#endregion


class MObywatelService {
   private readonly _client : HttpClient
   private readonly _mobywatelIdentificationQRCodePath = '/mobQrCode/identificationFullData'
   private readonly _mobywatelManualVerificationQRCodePath = '/mobQrCode/verificationManualData'

   constructor(){
      if (instance) { //SINGLETON DESIGN PATTERN
         throw new Error("New instance cannot be created!!");
      }
   
      instance = this;
      this._client = new HttpClient(Environment.apiUrl);
   }

   public async getMobywatelIdentificationCode(): Promise<IGetMobywatelQRCodeReturnProps> {
      return (await this._client.post<IGetMobywatelQRCodeReturnProps, IGetMobywatelQRCodeDTO>(
         this._mobywatelIdentificationQRCodePath,
         {},
         true
      )).data
   }

   public async getMobywatelManualVerificationCode(): Promise<IGetMobywatelQRCodeReturnProps> {
      return (await this._client.post<IGetMobywatelQRCodeReturnProps, IGetMobywatelQRCodeDTO>(
         this._mobywatelManualVerificationQRCodePath,
         {},
         true
      )).data
   }

}


let mObywatelService = Object.freeze(new MObywatelService())//SINGLETON DESIGN PATTERN
export default mObywatelService;